import { updateUrlSearch } from '../url';

const mapDateToDay = (date: Date): string => {
  const day = date.getDate();
  return `0${day}`.substr(-2);
};

const mapDateToMonth = (date: Date): string => {
  const year = date.getFullYear();
  const yearString = `${year}`.substr(-2);
  const month = date.getMonth() + 1;
  const monthString = `0${month}`.substr(-2);
  return `${yearString}${monthString}`;
};

type Mapping = {
  key: string;
  convert: (value: unknown) => string | boolean;
};

type InputParamKey =
  | 'OUTBOUND_MONTH'
  | 'INBOUND_MONTH'
  | 'OUTBOUND_DAY'
  | 'INBOUND_DAY'
  | 'PREFER_DIRECTS';

const inputParamMappings: Record<InputParamKey, Mapping> = {
  OUTBOUND_MONTH: {
    key: 'oym',
    convert: (date) => mapDateToMonth(date as Date),
  },
  INBOUND_MONTH: {
    key: 'iym',
    convert: (date) => mapDateToMonth(date as Date),
  },
  OUTBOUND_DAY: {
    key: 'selectedoday',
    convert: (date) => mapDateToDay(date as Date),
  },
  INBOUND_DAY: {
    key: 'selectediday',
    convert: (date) => mapDateToDay(date as Date),
  },
  PREFER_DIRECTS: {
    key: 'preferdirects',
    convert: (bool) => Boolean(bool),
  },
};

type MappedParams = Record<string, string | boolean>;

type InputParams = Record<string, unknown>;

const getMappedInputParams = (params: InputParams): MappedParams => {
  const mappedParams: MappedParams = {};
  Object.entries(params).map(([prop, value]) => {
    const mapping = inputParamMappings[prop as InputParamKey];
    if (mapping) {
      mappedParams[mapping.key] = mapping.convert(value);
    }
    return null;
  });
  return mappedParams;
};

const inputParamChanged = (params: InputParams): void => {
  const mappedParams = getMappedInputParams(params);
  updateUrlSearch(mappedParams);
};

export default inputParamChanged;
